import React from "react";

import {
  Box,
  Paper,
  styled,
  Divider,
  Container,
  Typography,
} from "@mui/material";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import LandingCurrentDateTime from "../LandingCurrentDateTime";
// ================================================================

const FullScreenContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: '100vh', // Ensure it fills the viewport height
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto', // Allows scrolling if content overflows
  // backgroundColor: 'gray', 
  // backgroundImage: `url(/assets/images/bookonline-bg1.jpg)`,
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url("/assets/images/bookonline-bg.jpeg")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'repeat',
  backgroundAttachment: 'fixed'
}));
const LogoBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "20px",
  left: "20px",
  backgroundColor: "#fff",
  padding: "10px 12px",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
  zIndex: 99
}));

const Root = styled(Paper)(({ theme }) => ({
  margin: theme.spacing(3),
  padding: theme.spacing(3),
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  borderRadius: theme.spacing(2),
}));

const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(3),
}));

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2), // Adjust margin top
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.primary.main, // Custom background color
}));

const FeedbackWithoutFeedbackScreen = () => {

  return (
    <FullScreenContainer>
      <LogoBox>
        <img src="/assets/images/JN_F_Logo.png" alt="Logo" style={{ width: "150px" }} />
      </LogoBox>
      <LandingCurrentDateTime />
      <Container maxWidth="md" sx={{ mt: 10 }}>
        <Root elevation={3}>
          <Box textAlign="center">
            <IconWrapper>
              <CheckCircleOutlineIcon color="primary" style={{ fontSize: 80 }} />
            </IconWrapper>
            <Typography variant="h4" gutterBottom>
              Thank You !
            </Typography>
            <CustomDivider />
            <Section>
              <Typography variant="body1">
                We appreciate you taking the time to share your thoughts with us.<br></br>
                Your feedback is invaluable and helps us continuously improve
                our services.
              </Typography>
            </Section>
            <Section>
              <Typography variant="body1" component="span" fontWeight="bold">
                Thank you for being a valued customer. Have a great day!
              </Typography>
            </Section>
          </Box>
        </Root>
      </Container>
    </FullScreenContainer>
  );
};

export default FeedbackWithoutFeedbackScreen;
